export default __webpack_public_path__ + "static/media/signupBG.0103d4e5.jpg";